var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17794 6.06895L0.807277 3.67693L0 4.48575L3.17794 7.69231L10 0.808811L9.19841 0L3.17794 6.06895Z",
    fill: "#508CC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMarkIcon);
export default __webpack_public_path__ + "static/media/tick-mark-icon.769bf8a9a9affd7e5150dfbb90f1d64a.svg";
export { ForwardRef as ReactComponent };